<div [ngClass]="{ 'popup-container': isCellEditorPopup }">
  <app-typeahead-field
    #fieldComponent
    [form-control]="formControl"
    [field]="cellParams.field"
    [panelClass]="typeAheadPanelClass"
  ></app-typeahead-field>
</div>
